import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const parseList = (v) => String(v || "").split(",").map((s) => s.trim()).filter(Boolean);
export const vkey = (s = "", c = "") => `${s}|${c}`;

export default function VariantStockGrid({ sizes, colors, value = {}, onChange, defaultQty = 0 }) {
  const sz = parseList(sizes);
  const cl = parseList(colors);
  if (sz.length === 0 && cl.length === 0) return null;
  const rows = sz.length ? sz : [""];
  const cols = cl.length ? cl : [""];
  const tracking = Object.keys(value || {}).length > 0;

  const set = (s, c, qty) => onChange({ ...(value || {}), [vkey(s, c)]: Math.max(0, parseInt(qty, 10) || 0) });
  const fillAll = (qty) => {
    const next = {};
    rows.forEach((s) => cols.forEach((c) => { next[vkey(s, c)] = Math.max(0, parseInt(qty, 10) || 0); }));
    onChange(next);
  };

  return (
    <div data-testid="variant-stock-grid">
      <div className="flex items-center justify-between gap-2">
        <Label className="text-xs font-bold uppercase tracking-widest text-zinc-700">Stock per size / color</Label>
        <div className="flex gap-1">
          <Button type="button" size="sm" variant="outline" className="h-7 text-[11px]" data-testid="variant-stock-fill-btn" onClick={() => fillAll(defaultQty || 5)}>Fill all with {defaultQty || 5}</Button>
          {tracking && <Button type="button" size="sm" variant="outline" className="h-7 text-[11px] text-zinc-500" data-testid="variant-stock-clear-btn" onClick={() => onChange({})}>Don't track</Button>}
        </div>
      </div>
      <p className="text-[10px] text-zinc-500 mt-1">
        {tracking ? "Customers can only pick options with stock above 0. Sold-out options show crossed out." : "Not tracking per option — every size/color is shown as available (overall stock applies). Fill in numbers to start tracking."}
      </p>
      <div className="mt-2 overflow-x-auto rounded-md border border-zinc-200">
        <table className="w-full text-xs">
          <thead className="bg-zinc-50">
            <tr>
              <th className="text-left px-2 py-1.5 font-bold text-zinc-600">{sz.length ? "Size" : ""}</th>
              {cols.map((c) => <th key={c} className="px-2 py-1.5 font-bold text-zinc-600 text-center">{c || "Qty"}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((s) => (
              <tr key={s} className="border-t border-zinc-100">
                <td className="px-2 py-1 font-bold text-[#0C2E2B]">{s}</td>
                {cols.map((c) => {
                  const k = vkey(s, c);
                  const q = value?.[k];
                  return (
                    <td key={k} className="px-1 py-1">
                      <Input data-testid={`variant-stock-${s || "x"}-${c || "x"}`} type="number" min={0} value={q ?? ""} placeholder="—"
                        onChange={(e) => set(s, c, e.target.value)}
                        className={`h-8 w-20 mx-auto text-center ${q === 0 ? "border-red-300 bg-red-50 text-red-700" : ""}`} />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
